import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

// Corrigindo o nome "NotificatioContext" para "NotificationContext"
const NotificationContext = createContext({
  notifications: [],
});

export const useNotifications = () => useContext(NotificationContext);

class NotificationItem {
  constructor(message, date, title, read, href, hrefText) {
    this._read = read;
    this._description = message;
    this._date = date;
    this._title = title;
    this._href = href;
    this._hrefText = hrefText;
  }

  toJSON() {
    return {
      read: this._read,
      description: this._description,
      title: this._title,
      date: this._date,
      href: this._href,
      hrefText: this._hrefText,
    };
  }
}

const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [notificationsList, setNotificationsList] = useState({});

  useEffect(() => {
    const list = Object.values(notificationsList);
    setNotifications(list);
  }, [notificationsList]);

  const checkIfNotificationExist = useCallback(
    (notificationName) => {
      return !!notificationsList[notificationName];
    },
    [notificationsList]
  );

  const handleAddNotification = useCallback(
    (notificationName, { message, read, date, title, href, hrefText }) => {
      const list = { ...notificationsList };
      list[notificationName] = new NotificationItem(
        message,
        date,
        title,
        read,
        href,
        hrefText
      );
      setNotificationsList((prev) => ({ ...prev, ...list }));
      setNotifications((prev) => [...prev, list[notificationName]]);
    },
    [notificationsList]
  );

  const getNotificationByName = useCallback(
    (notificationName) => notificationsList[notificationName],
    [notificationsList]
  );

  const clearNotificationByName = useCallback(
    (notificationName) => {
      const list = { ...notificationsList };
      delete list[notificationName];
      setNotificationsList(list);
      setNotifications(Object.values(list));
    },
    [notificationsList]
  );

  const value = useMemo(
    () => ({
      notifications,
      addNotification: handleAddNotification,
      clearNotificationByName,
      checkIfNotificationExist,
      getNotificationByName,
    }),
    [
      notifications,
      handleAddNotification,
      getNotificationByName,
      clearNotificationByName,
      checkIfNotificationExist,
    ]
  );

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
